import { z } from 'zod'
import { DateModel } from '../../_kernel/DateModel'
import { Model } from '../../_kernel/architecture'
import { ListOfPax } from './ListOfPax'

export const PartialSearchValidation = z.object({
  checkIn: z.instanceof(DateModel, { message: 'checkIn is required' }),
  checkOut: z.instanceof(DateModel, { message: 'checkOut is required' }),
  paxes: z.instanceof(ListOfPax, { message: 'paxes is required' }),
})

export class PartialSearch extends Model {
  static create({ checkIn, checkOut, paxes }: z.infer<typeof PartialSearchValidation>) {
    PartialSearchValidation.parse({ checkIn, checkOut, paxes })
    return new PartialSearch(checkIn, checkOut, paxes)
  }

  static default() {
    const today = new Date()
    const threeDaysLater = new Date(today)
    threeDaysLater.setDate(today.getDate() + 3)

    return new PartialSearch(
      DateModel.fromGlobalDate(today),
      DateModel.fromGlobalDate(threeDaysLater),
      ListOfPax.default()
    )
  }

  static fromCheckInOffset(checkInOffset: number) {
    const today = new Date()
    const checkIn = DateModel.fromGlobalDateOffset(today, checkInOffset)
    const checkOut = DateModel.fromGlobalDateOffset(today, checkInOffset + 3)

    return new PartialSearch(checkIn, checkOut, ListOfPax.default())
  }

  static fromJSON(json: ReturnType<PartialSearch['toJSON']>): PartialSearch {
    return PartialSearch.create({
      checkIn: DateModel.fromDateTimeOrEmpty(json.checkIn),
      checkOut: DateModel.fromDateTimeOrEmpty(json.checkOut),
      paxes: ListOfPax.fromJSON({ list: json.paxes }),
    })
  }

  constructor(
    private readonly _checkIn: DateModel,
    private readonly _checkOut: DateModel,
    private readonly _paxes: ListOfPax
  ) {
    super()
  }

  get checkIn() { return this._checkIn.value } // prettier-ignore
  get checkOut() { return this._checkOut.value } // prettier-ignore
  get paxes() { return this._paxes } // prettier-ignore

  toJSON() {
    return {
      checkIn: this.checkIn,
      checkOut: this.checkOut,
      paxes: this.paxes.toJSON().list,
    }
  }
}
